// @flow

// Util that checks the internal React Flow representation of a Node
// and returns whether it has defined height and width (meaning it's been rendered)

export const hasDimensions = (n: any): boolean => {
  return n && n.__rf.width !== null && n.__rf.height !== null;
};
